// src/mocks/browser.js
import { setupWorker } from 'msw';
import { handlers } from './AlarmHandler';

export const worker = setupWorker(...handlers);
